// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinkOutlinedSvg from "@fishx/icons-svg/es/asn/LinkOutlined";
import FishxIcon from '../components/FishxIcon';

var LinkOutlined = function LinkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinkOutlinedSvg
  }));
};

LinkOutlined.displayName = 'LinkOutlined';
export default React.forwardRef(LinkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LinkOutlined.js
// module id = 3052
// module chunks = 0